'use strict';
/// <reference path="../../../typings/customTds.d.ts"/>

import { App } from "./controller/App";

window.InstanceCollection = window.InstanceCollection || {};

const $jq = window.$jq || jQuery.noConflict();
if (!$jq.ADAC) {
	$jq.ADAC = {};
}
window.$ = jQuery;
// Create the defaults once
const pluginName = 'MembershipModularSystemApplicationV2',
	namespace = 'ADAC', fqname = `${namespace}_${pluginName}`;

// The actual plugin constructor
$jq.ADAC[pluginName] = function (element, options, loader) {
	this.tid = options.app.tid;
	this.element = element;
	this.loader = loader;
	this.options = options;
	this.options.$jq = $jq;
	this._name = pluginName;

	this.application = new App(this.element, this.options, this.loader);
	this.application.start();


	// declare public methods
	window.InstanceCollection[pluginName] = this;
};

$jq.fn[fqname] = function (options, loader) {
	return this.each(function () {
		if (!$jq.data(this, fqname)) {
			$jq.data(this, fqname,
				new $jq.ADAC[pluginName](this, options, loader));
		}
	});
};
/*! Version: 3.190.0.110655; Commit: 37ddbdd3b544e17d72e71b7773c65d2b87a26436 */
